import React, { useState } from 'react';
import ModalWrapper from '../../components/elements/ModalWrapper';
import { StatusRedeem } from '.';
import { Box, Group, Image, Stack, Text } from '@mantine/core';
import { getSharepointCdnFileMedia } from '../../utilities';
import LabelDate from '../../components/fragments/LabelDate';
import Badge from '../../components/elements/Badge';
import Button from '../../components/elements/Button';
import ModalConfirmationAction from './ModalConfirmationAction';
import { HiCheck, HiXMark } from 'react-icons/hi2';

interface ModalActionVoucherRedeemProps {
  opened: boolean;
  onClose: () => void;
  type: 'detail' | 'action';
  data: {
    status: StatusRedeem;
    rewardImage: string;
    redeemBy: string;
    inventoryName: string;
    dateIn: string;
    notes: string;
  };
}

const ModalActionVoucherRedeem: React.FC<ModalActionVoucherRedeemProps> = ({
  opened,
  onClose,
  type,
  data
}) => {
  const [modalConfig, setModalConfig] = useState({
    show: false,
    data: null,
    type: 'reject'
  });

  const handleCloseModal = () => {
    setModalConfig({
      show: false,
      data: null,
      type: 'reject'
    });
  };

  const handleOpenModal = (type: 'reject' | 'approve') => {
    setModalConfig({
      show: true,
      data: data,
      type: type
    });
  };

  const renderBadge = (status: StatusRedeem) => {
    const color = () => {
      switch (status) {
        case 'Approved':
          return 'green';
        case 'Rejected':
          return 'red';
        default:
          return 'orange';
      }
    };

    const label = () => {
      switch (status) {
        case 'Approved':
          return 'Approved';
        case 'Rejected':
          return 'Rejected';
        default:
          return 'Waiting';
      }
    };
    return (
      <Badge variant="light" color={color()}>
        {label()}
      </Badge>
    );
  };

  return (
    <>
      <ModalWrapper
        isVisible={opened}
        onClose={onClose}
        title={type === 'detail' ? `${data?.status} Voucher` : 'Action Voucher'}
      >
        <Group my={8}>
          <Box component="div">
            <Image
              src={getSharepointCdnFileMedia(data?.rewardImage)}
              w={120}
              h={120}
              radius="full"
              mb={10}
            />
          </Box>
          <Stack gap={'xs'}>
            {data?.status !== 'Diambil' && (
              <Group>
                <Text className="text-sm-medium">Status :</Text>
                {renderBadge(data?.status)}
              </Group>
            )}
            <Group>
              <Text className="text-sm-medium">Redeemer :</Text>
              <Text className="text-sm-bold">{data?.redeemBy}</Text>
            </Group>
            <Group>
              <Text className="text-sm-medium">Voucher :</Text>
              <Text className="text-sm-bold">{data?.inventoryName}</Text>
            </Group>
            <Group>
              <Text className="text-sm-medium">Redeem Date :</Text>
              <Text className="text-sm-bold">
                <LabelDate date={data?.dateIn} />
              </Text>
            </Group>
            <Group>
              <Text className="text-sm-medium">Notes :</Text>
              <Text className="text-sm-bold">{data?.notes || '-'}</Text>
            </Group>
          </Stack>
        </Group>

        {data?.status === 'Diambil' && (
          <Group justify="space-between">
            <Button variant="error-beelajar" onClick={onClose}>
              Cancel
            </Button>
            <Group>
              <Button
                variant="error"
                leftSection={<HiXMark />}
                onClick={() => handleOpenModal('reject')}
              >
                Reject
              </Button>
              <Button
                leftSection={<HiCheck />}
                onClick={() => handleOpenModal('approve')}
              >
                Approve
              </Button>
            </Group>
          </Group>
        )}
      </ModalWrapper>

      <ModalConfirmationAction
        onClose={handleCloseModal}
        onSubmit={() => {
          handleCloseModal();
          onClose();
        }}
        opened={modalConfig?.show}
        type={modalConfig?.type}
        data={modalConfig?.data}
      />
    </>
  );
};

export default ModalActionVoucherRedeem;
